import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";

import { ProductsStatisticsPage } from "./Products";
import { SalesStatisticsPage } from "./Sales";
import { LayoutSplashScreen, ContentRoute } from "../../../_metronic/layout";

import { URLs } from "../../../utils/routes";

export function StatisticsPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Redirect exact={true} from={URLs.STATISTICS} to={URLs.STATISTICS_SALES} />
        <ContentRoute path={URLs.STATISTICS_SALES} component={SalesStatisticsPage} />
        <ContentRoute path={URLs.STATISTICS_PRODUCTS} component={ProductsStatisticsPage} />
      </Switch>
    </Suspense>
  );
}
